exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email_link[data-v-230c178e]{color:#00e;text-decoration:underline}", ""]);

// exports
